export enum EColorLastBalls {
  RED = 'red',
  BLACK = 'black',
  GREEN = 'green',
  NO_SPIN = 'no spin',
}
